import { TabsList, TabsTrigger } from "../../components/ui/tabs"

export type CategoryTabsHeaderProps = {
  categories: string[]
  servicesByCategory: Record<string, { length: number } | any[]>
  totalServices: number
  onSelect: (val: string) => void
}

export const CategoryTabsHeader = ({
  categories,
  servicesByCategory,
  totalServices,
}: CategoryTabsHeaderProps) => {
  return (
    <div>
      <TabsList className="overflow-x-auto no-scrollbar flex-1">
        <TabsTrigger value="all">Toutes ({totalServices})</TabsTrigger>
        {categories.map((category) => (
          <TabsTrigger key={category} value={category}>
            {category} ({servicesByCategory[category].length})
          </TabsTrigger>
        ))}
      </TabsList>
    </div>
  )
}

export default CategoryTabsHeader
